import { messages as messagesEN } from './en';

export const messages: typeof messagesEN = {
  HOME: { TITLE: 'inicio', ROUTE: '/home' },
  ABOUT: { TITLE: 'Acerca de la aplicación', ROUTE: '/about' },
  DEFINE_BOX: { TITLE: 'Caja morfológica', ROUTE: '/define' },
  SETTINGS: { TITLE: 'Configuración', ROUTE: '/settings' },
  CREATE_SCENARIO: { TITLE: 'Crear escenario', ROUTE: '/create' },
  SHOW_SCENARIO: { TITLE: 'Mostrar escenarios', ROUTE: '/show' },
  DECISION_SUPPORT: { TITLE: 'Apoyo a la decisión', ROUTE: '/decide' },
  DOWNLOAD: {
    COLLECTION: 'Guardar colección',
    MODEL: 'Guardar archivo de caja',
  },
  DOWNLOAD_FILENAME_TITLE: 'Guardar archivo de caja',
  DOWNLOAD_FILENAME_LABEL: 'Nombre del archivo',
  UPLOAD: {
    COLLECTION: 'Cargar colección',
    MODEL: 'Cargar archivo de caja',
  },
  OPEN_MENU: 'Abrir menú',
  UPLOAD_FILE: 'Cargar caja o colección',
  IMPORT_READ_ERROR: 'No se pudo leer el archivo seleccionado.',
  COLLECTION_LOAD_FAILED: 'No se pudo cargar la colección. Compruebe su conexión y vuelva a cargar la página.',
  STARTER_KIT_LOAD_FAILED: 'No se pudo cargar el kit inicial. Compruebe su conexión e inténtelo de nuevo.',
  IMPORT_COLLECTION_TITLE: '¿Reemplazar la colección?',
  IMPORT_COLLECTION_MSG:
    'Este archivo contiene una colección. Al cargarla, se reemplazará la colección actual, incluidos los cambios no guardados. ¿Continuar?',
  CANCEL: 'Cancelar',
  DELETE: 'Eliminar',
  AND: 'y',
  YES: 'Sí',
  NO: 'No',
  OK: 'Ok',
  NAME: 'Nombre',
  DESCRIPTION: 'Descripción',
  NEW_BOX: 'Nueva caja morfológica',
  CATEGORIES: 'Categorías',
  DIMENSION: 'Factor clave',
  DIMENSION_SELECTED: 'Factores seleccionados',
  DIMENSIONS: 'Factores',
  KEY_VALUE: 'Valor clave',
  OPTION_USAGE_LEGEND: 'Uso de opciones en los escenarios incluidos',
  OPTION_USAGE_RANGE: 'Usada {range} veces en los escenarios incluidos',
  OPTION_USAGE_COUNT: 'usada {count} veces',
  CONTEXT: 'Contexto',
  NONE: 'Ninguno',
  LOCATION: 'Ubicación',
  LOCATION_TYPE: 'Tipo de ubicación',
  COORDINATES: 'Coordenadas',
  LOCATION_NAME: 'Nombre de ubicación',
  LATITUDE: 'Latitud',
  LONGITUDE: 'Longitud',
  MANUAL: 'Modo manual',
  Type: 'Tipo',
  PICK_FROM_LIST: 'Seleccionar de la lista',
  ENTER_KEY_VALUE: 'Introducir valor clave',
  EDIT_COMPONENT: 'Editar componente',
  ADD_COMPONENT: 'Agregar componente',
  GENERATE_NARRATIVE: 'Generar',
  CLEAR_NARRATIVE: 'Limpiar',
  NAME_NARRATIVE: 'Título del escenario actual',
  SAVE_NARRATIVE: 'Guardar',
  SAVED_NARRATIVES: 'Escenarios guardados',
  HOME_WORK_TITLE: "Elija un tipo de escenario",
  HOME_WORK_HINT: "Empiece con un tipo de escenario listo para usar del kit de inicio y úselo para crear y comparar escenarios.",
  HOME_OPTIONS_TITLE: "Adaptar o crear el suyo",
  HOME_EDIT_CARD_TITLE: "Adaptar un tipo de escenario",
  HOME_EDIT_CARD_DESC: "Añada, modifique o elimine factores y opciones para que el tipo elegido se ajuste a su situación.",
  HOME_AI_CARD_TITLE: "Crear un nuevo tipo de escenario",
  HOME_AI_CARD_DESC: "Deje que la IA proponga una caja morfológica para su tema, o empiece usted mismo con una caja vacía.",
  HOME_MAP_CARD_TITLE: "Escenarios en el mapa",
  HOME_MAP_CARD_DESC: "¿Su escenario transcurre en lugares reconocibles, como una central nuclear o un monumento? Active el mapa, abra Editar caja y, con el lápiz de una opción, añada coordenadas o un tipo de lugar. Esos lugares aparecerán en el mapa de sus escenarios.",
  HOME_MAP_CARD_ENABLE: "Activar el mapa",
  HOME_MAP_CARD_ENABLED: "El mapa está activado. Añada lugares a las opciones mediante Editar caja.",
  TUTORIAL_CARD_TITLE: "Tutorial",
  TUTORIAL_CARD_DESC: "Vea cómo generar un escenario completo de una vez con un asistente de IA: narrativa, reflexiones sobre los cursos de acción y opiniones de las personas.",
  TUTORIAL_WATCH: "Ver tutorial",
  TUTORIAL_TITLE: "Tutorial: un escenario completo con IA",
  TUTORIAL_DESC: "Del kit de inicio a la decisión: genere un escenario, deje que un asistente de IA escriba la narrativa, las reflexiones y las opiniones de las personas en JSON, péguelo y analice los resultados.",
  TUTORIAL_NARRATION: "Idioma de la narración",
  HOME_MAP_CARD_ACTIVE: "El mapa está activado para este tipo de escenario.",
  HOME_MAP_CARD_LOCATIONS: "Añadir lugares",
  DECISION_BANNER_MSG: "Este tipo de escenario contiene medidas para el apoyo a la decisión. Actívelo para elegir medidas, comparar opciones de actuación y registrar decisiones.",
  DECISION_HELP_TITLE: "¿Cómo funciona el apoyo a la decisión?",
  DECISION_HELP_STEP1: "En Crear escenario, describa la situación: elija los factores del incidente y guarde el escenario.",
  DECISION_HELP_STEP2: "En Decisiones, elija las medidas que se ajustan a la situación. Cada conjunto de medidas es una opción de actuación; cree varias para comparar alternativas.",
  DECISION_HELP_STEP3: "Estime para cada opción de actuación la probabilidad y el impacto residuales.",
  DECISION_HELP_STEP4: "Compare aquí las opciones de actuación en el resumen, la comparación, la vista de robustez y la matriz de riesgos.",
  DECISION_HELP_STEP5: "Registre la decisión y su justificación en el registro de decisiones y exporte todo a Word.",
  PERSONA_CLIPBOARD_HINT: "No hay ningún modelo de lenguaje conectado, así que el botón copia un prompt: péguelo en el chat de su asistente de IA y pegue la respuesta en el campo de comentarios de la persona. Conecte un modelo de lenguaje en Configuración → LLM para generar los comentarios directamente.",
  SETUP_LLM: "Configurar modelo de lenguaje",
  NARRATIVE_PROMPT_COPIED: "Prompt de la historia copiado. Péguelo en el chat de su asistente de IA y pegue la respuesta en el campo de la historia.",
  EDIT_BOX: 'Editar caja',
  NO_SAVED_NARRATIVES: 'Aún no hay escenarios guardados en esta caja. Cree uno para empezar.',
  NO_MATCHING_NARRATIVES: 'Ningún escenario coincide con esta búsqueda.',
  OPEN_SCENARIO: 'Abrir escenario',
  COMPARE_SCENARIOS: 'Comparar escenarios',
  HIDE_COMPARISON: 'Ocultar comparación',
  BOX_ACTIONS: 'Más acciones',
  PERMALINK: 'Copiar enlace permanente',
  PERMALINK_COPIED: 'Enlace permanente copiado al portapapeles. Péguelo en un correo para compartir esta caja.',
  PERMALINK_COPIED_LONG: 'Enlace copiado, pero es muy largo: algunos clientes de correo pueden cortarlo. Considere enviar el archivo descargado.',
  PERMALINK_INVALID: 'El enlace compartido no es válido o está incompleto.',
  COLLECTION_ACTIONS: 'Gestión de la colección',
  LANGUAGE_NAMES: {
    nl: 'Nederlands', en: 'English', fr: 'Français',
    de: 'Deutsch', es: 'Español', pl: 'Polski',
  },
  FILTER_NARRATIVES: 'Filtrar escenarios',
  FILTER_NARRATIVES_PLACEHOLDER: 'Escriba para filtrar por nombre...',
  NARRATIVE: 'escenario',
  INCLUDE_NARRATIVE: "Seleccionar para análisis",
  NARRATIVE_INCLUDED: "Seleccionado para análisis",
  SELECT_NARRATIVE: 'Seleccionar escenario',
  SELECT_SCENARIO: "Tipo de escenario",
  SELECT_GROUP_OWN: "Mis tipos de escenario",
  SELECT_GROUP_STARTER: "Kit inicial",
  KEY: 'Clave',
  VALUE: 'Valor',
  MODEL: 'Modelo',
  SELECTION: 'Valor seleccionado',
  EDITOR_PLACEHOLDER: 'Editar escenario',
  THRESHOLDS: 'Colores de umbral que reflejan opciones de componentes',
  THRESHOLD: 'Valor de umbral',
  COLOR: 'Color',
  ORDER: 'Orden',
  COMBINATIONS: {
    POSSIBLE: 'Las combinaciones son posibles',
    IMPOSSIBLE: 'Las combinaciones son imposibles',
    IMPROBABLE: 'Las combinaciones son improbables',
  },
  DELETE_ITEM: {
    title: 'Eliminar {item}',
    description:
      '¿Está seguro de que desea eliminar este {item}? No hay vuelta atrás.',
  },
  NEW_SCENARIO: 'Nueva caja',
  ADD_STARTER_KIT: 'Añadir o actualizar kit inicial',
  ADD_STARTER_KIT_HINT: 'Añade las cajas y personas que faltan y actualiza las que no se han modificado. Los elementos modificados solo se sustituyen tras su confirmación.',
  STARTER_KIT_ADDED: 'Kit inicial: {added} añadidos, {updated} actualizados.',
  STARTER_KIT_CONFLICT_TITLE: '¿Sobrescribir elementos modificados?',
  STARTER_KIT_CONFLICT_MSG: 'Ha modificado estos elementos del kit. Seleccione los que desea sustituir por la versión actual del kit inicial. Se perderán sus cambios, incluidos relatos y decisiones. Los elementos no seleccionados se mantienen.',
  STARTER_KIT_SELECT_ALL: 'Seleccionar todo',
  STARTER_KIT_UPDATE: 'Actualizar',
  STARTER_KIT_KIND_BOX: 'caja',
  STARTER_KIT_KIND_PERSONA: 'persona',
  STARTER_KIT_ALREADY_PRESENT: 'El kit inicial ya está actualizado.',
  NEW_MODEL: {
    btn: 'Nueva colección',
    title: 'Elegir una nueva colección',
    description:
      'Se reemplazará su colección actual. Descárguela primero si desea conservarla.',
    choose: 'Elija su nueva colección',
  },
  DELETE_MODEL: {
    btn: 'Eliminar caja',
    title: 'Eliminar la caja seleccionada',
    description:
      '¿Eliminar esta caja y sus escenarios guardados? Esta acción no se puede deshacer.',
  },
  INCONSISTENCIES: {
    title: 'Inconsistencias',
    SELECT_ROW_CATEGORY: 'Seleccionar categoría de fila',
    SELECT_COLUMN_CATEGORY: 'Seleccionar categoría de columna',
    SELECT_CATEGORIES_TO_START: 'Seleccionar categorías para comenzar',
    NO_DRIVERS:
      'No hay impulsores clave con valores disponibles para esta combinación de categorías',
    NAV_TITLE: 'Navegación con teclado',
    NAV_ARROWS:
      'Flechas: moverse entre celdas, con Shift entre impulsores clave',
    NAV_TOGGLE: 'Espacio o Enter: cambiar estado de combinación',
    NAV_SHIFT_VERTICAL:
      'Shift + Arriba/Abajo: cambiar impulsor clave de fila activo',
    NAV_SHIFT_HORIZONTAL:
      'Shift + Izquierda/Derecha: cambiar impulsor clave de columna activo',
  },
  saveButton: {
    label: 'Guardar',
    tooltip: 'Guardar cambios no guardados',
  },
  i18n: {
    /** Label for the edit button of the RepeatList */
    editRepeat: 'Editar',
    /** Label for the create button of the RepeatList */
    createRepeat: 'Agregar',
    /** Label for the delete button of the RepeatList */
    deleteItem: 'Eliminar',
    /** Label for the agree button of the RepeatList */
    agree: 'Sí',
    /** Label for the disagree button of the RepeatList */
    disagree: 'No',
    /** Pick */
    pick: 'Seleccionar',
    /** Pick one */
    pickOne: 'Seleccionar uno',
    /** Pick one or more */
    pickOneOrMore: 'Seleccionar uno o más',
    /** Cancel button text */
    cancel: 'Cancelar',
    /** Save button text */
    save: 'Guardar',
  },
  COMP: {
    AVAILABLEBUDGET: 'Presupuesto',
    BEHAVIOURDURINGPREPARATION: 'Comportamiento durante la preparación',
    CAPABILITIES: 'Capacidad',
    COMPARTMENTSPRESENT: 'Compartimentos presentes',
    CRIMINALPHASE: 'Fase criminal',
    DURATION: 'Duración',
    EQUIPMENT: 'Equipamiento',
    EXISTINGINFRA: 'Infraestructura existente',
    IMPACT: 'Impacto',
    INTENT: 'Intención del espectador',
    LOCATION: 'Ubicación',
    LOCATION2: 'Ubicación',
    MODUSOPERANDIDURINGEXECUTION: 'Modo de operación',
    MOTIVATION: 'Motivación',
    NARRATIVE: 'Narrativa',
    NARRATIVE_PLACEHOLDER:
      'Describa el contexto en el que tuvo lugar el incidente, como una descripción de la ubicación (geográfica), la persona o edificio que debe protegerse, la forma en que un actor obtiene información, a qué hora se realizó la acción, bajo qué circunstancias climáticas, cuántas personas participaron en la acción, de qué organización, cómo obtuvieron acceso o qué medios/armas se emplearon.',
    OBJECT: 'Objeto',
    OPENCOMPARTMENTS: 'Compartimento abierto',
    PEOPLEDENSITY: 'Densidad de personas',
    PERSONS: 'Persona',
    PHYSICALANGLEOFATTACKDURINGEXECUTION: 'Ángulo físico de ataque',
    PHYSICAL_ANGLE: 'Ángulo físico',
    PRIVACYAWARENESS: 'Conciencia de privacidad',
    RELATIONOWNEROBJECTANDOWNERSECURITYSYSTEM:
      'Relación propietario del objeto y propietario del sistema de seguridad',
    RESPONSIBILITY: 'Responsabilidad',
    SCENARIOS: 'Escenario',
    SECURITYAWARENESS: 'Conciencia de seguridad',
    TARGETTYPE: 'Tipo de objetivo',
    THREATDIRECTION: 'Dirección de amenaza',
    ACTOR: 'Actor',
    ACTION: 'Acción',
    ACCESS: 'Acceso',
    MEANS: 'Medios',
    TYPEOFENVIRONMENT: 'Tipo de entorno',
    TYPEOFOBJECT: 'Tipo de objeto',
    WEAPON: 'Arma',
    WEATHERBEHAVIOUR: 'Comportamiento climático',
    WEATHERTYPE: 'Condición climática',
    PI: 'Interés protegido (objetivo)',
    MEANSWEAPON: 'Medios/arma',
    MISSIONCONTEXT: 'Contexto de misión',
    ADVERSARY: 'Adversario',
    C2HEADQUARTERS: 'Ubicación C2-HQ',
    TARGET: 'Objetivo',
    DELIBERATEACTION: 'Acción deliberada',
    MEANS2: 'Medios de ataque',
    MEANS3: 'Medios para acción',
    MEANS4: 'Medios para acceso',
    ACCESS2: 'Medios de acceso',
    MEANS2ACCESS: 'Medios para acceder',
  },
  MODEL_NAMES: {
    0: 'Modelo vacío',
    1: 'Kit inicial',
  },
  MODEL_DESC: {
    0: 'Comenzar con una caja morfológica vacía.',
    1: 'Diez cajas de ejercicios en español con ejemplos, restricciones, plantillas de texto e indicaciones para el LLM.',
  },
  JSON_NOT_VALID: '¡El archivo de modelo JSON no es válido! Abortando.',
  NO_NARRATIVE: '¡No se generó ningún escenario en 100 intentos!',
  ALL_LOCKED_WARNING:
    'Todos los componentes están bloqueados — no se puede generar un nuevo escenario. Borre primero el escenario actual.',
  SPEC_CATS:
    'Primero especifique algunas categorías, donde cada categoría contiene algunos factores clave.',
  TRANSPOSE_BOX: {
    COLUMNS: 'Mostrar los factores clave como columnas',
    ROWS: 'Mostrar los factores clave como filas',
  },
  EXPORT2WORD: {
    TITLE: 'Exportar a Word',
    DESC: '¿Qué escenario desea exportar?',
    CURRENT: 'Actual',
    SELECTED: 'Seleccionado',
    ALL: 'Todos',
    INCLUDE_BOX: 'Incluir la caja morfológica (una tabla por categoría, con los valores seleccionados resaltados)',
    INCLUDE_DECISIONS: 'Incluir el análisis de decisiones (resumen, comparación de cursos de acción, matriz de riesgos y registro de decisiones)',
  },
  HIDE_INCONSISTENT: 'Ocultar combinaciones inconsistentes',
  GOAL: {
    TITLE: 'Objetivo',
    DESC: 'ScenarioSpark es una aplicación web que puede utilizarse para crear y gestionar sistemáticamente un conjunto de escenarios para actividades de gestión de riesgos.',
  },
  USAGE: {
    TITLE: 'Uso',
    DESC: 'ScenarioSpark apoya al usuario en la creación y compilación de un conjunto representativo de escenarios que pueden utilizarse en las diversas etapas del proceso de gestión de riesgos.',
  },
  SECURITY: {
    TITLE: 'Seguridad',
    DESC: 'Toda la información utilizada e introducida se procesa y almacena exclusivamente de forma local.',
  },
  SUMMARY:
    'Una herramienta gratuita para ayudarle a crear nuevos escenarios utilizando una caja morfológica. Primero, defina los aspectos que son de interés en su dominio. Luego, especifique variaciones para cada aspecto. Y finalmente, cree manualmente nuevos escenarios o inspírese generando escenarios posibles automáticamente.',
  SET_LANGUAGE: 'Establecer idioma',
  SCENARIO_LOADED_MSG: 'Caja cargada',
  COLLECTION_LOADED_MSG: 'La colección de cajas está cargada',
  SCENARIO_NOT_LOADED_MSG:
    'La caja no se ha cargado: es posible que ya esté en la colección.',
  IMPORT_CONFLICT_TITLE: 'La caja ya existe',
  IMPORT_CONFLICT_MSG:
    'Una caja llamada "{name}" ya está en tu colección. ¿Qué quieres hacer?',
  IMPORT_OVERWRITE: 'Sobrescribir',
  IMPORT_AS_COPY: 'Agregar como copia',
  SCENARIO_CREATED_MSG: 'Caja creada',
  COPY_TO_CLIPBOARD: 'Copiar tabla al portapapeles',
  GROUP: {
    SELECTED: 'Escenarios seleccionados',
    UNSELECTED: 'Escenarios no seleccionados',
  },
  MORE_ACTIONS: 'Más acciones',
  CLONE_NARRATIVE: 'Clonar',
  INCLUDE_DECISION_SUPPORT: 'Activar apoyo a la decisión',
  IS_DECISION_CATEGORY: 'Para apoyo a la decisión',
  DECISION_CATEGORY_HINT: "Los factores de una categoría de decisión son manuales: no se generan, usted los elige después de describir la situación. Las categorías de decisión solo se muestran cuando el apoyo a la decisión está activado.",
  DECISION_CATEGORIES_HIDDEN: "Las categorías de decisión ({count}) están ocultas.",
  DECISION_CATEGORIES_OPEN_SETTINGS: "Abrir Configuración",
  DECISIONS: "Decisiones",
  DECISIONS_HINT: "Elija las medidas que se ajustan a la situación anterior. Las opciones incompatibles con la situación aparecen en gris.",
  EXCLUDED_BY: "excluido por {situation}",
  COURSES_OF_ACTION: "Líneas de acción",
  COURSE_OF_ACTION: "Línea de acción",
  COA_ACTIVE: "activa",
  ADD_COA: "Añadir",
  DUPLICATE_COA: "Duplicar",
  RENAME_COA: "Renombrar línea de acción",
  DELETE_COA: "Eliminar línea de acción",
  COA_NAME: "Nombre de la línea de acción",
  COA_NOTES: "Notas sobre esta línea de acción",
  COA_HAS_CONFLICTS: "Contiene medidas incompatibles con la situación",
  COA_CONFLICT: "{value} es incompatible con la situación ({situation})",
  REFLECT_ON_DECISIONS: "Preguntar al LLM: reflexionar sobre las decisiones",
  COA_REFLECTION: "Reflexión sobre esta línea de acción",
  DECISION_PROMPT_COPIED: "Prompt de decisión copiado. Péguelo en el chat de su asistente de IA y pegue la respuesta en el campo de reflexión.",
  DECISION_REFLECTION_ERROR: "No se pudo generar ni copiar la reflexión. Inténtelo de nuevo.",
  DECISION_REFLECTION_DISCARDED: "La reflexión no se guardó: el escenario o la línea de acción cambió mientras se generaba.",
  NO_DECISION_CATEGORIES: "Esta caja no tiene categorías de decisión. Marque una categoría como «Para apoyo a la decisión» en Ajustes para comparar medidas aquí.",
  DECISION_VIEW_OVERVIEW: "Resumen",
  DECISION_VIEW_COA: "Comparar líneas de acción",
  DECISION_VIEW_ROBUSTNESS: "Robustez",
  COMPARE_SCENARIO: "Escenario a comparar",
  SHOW_DIFFERENCES_ONLY: "Mostrar solo diferencias",
  NO_INCLUDED_NARRATIVES: "Todavía no hay escenarios seleccionados para el análisis. Seleccione escenarios en la página Crear escenario para compararlos aquí.",
  NO_CURRENT_NARRATIVE: "No hay ningún escenario abierto. Abra o guarde primero un escenario en la página Crear escenario.",
  NO_COAS: "Este escenario aún no tiene líneas de acción. Añádalas en la página Crear escenario.",
  NO_COA_DIFFERENCES: "Todas las líneas de acción eligen las mismas medidas.",
  NO_DECISION_SELECTED: "ninguna",
  ROBUSTNESS_HINT: "¿Qué medidas se mantienen en el escenario actual y en los seleccionados para el análisis? Cada columna es un escenario con su línea de acción activa; una medida elegida en todos los escenarios es un primer paso seguro, una elegida en un solo escenario depende de cómo evolucione la situación.",
  ROBUSTNESS_ONE_SCENARIO: "La robustez compara dos o más escenarios. Guarde otro escenario en la página {page} y selecciónelo para el análisis para ver qué medidas se mantienen en todos ellos.",
  SCENARIO_CURRENT: "actual",
  ROBUSTNESS_MEASURE: "Medida",
  ROBUSTNESS_CHOSEN: "Elegida",
  ROBUSTNESS_EXCLUDED: "Excluida por la situación",
  ROBUSTNESS_UNUSED: "No utilizada",
  ROBUSTNESS_CHOSEN_IN: "Elegida en",
  ROBUSTNESS_COUNT: "{count} de {total}",
  ROBUSTNESS_ROBUST: "Robusta: elegida en todos los escenarios",
  ROBUSTNESS_SPECIFIC: "Específica de un escenario: elegida en un solo escenario",
  SUGGESTED_WHY: "Por qué esta sugerencia",
  SUGGESTED_HINT: "Por factor, las medidas con la mayor puntuación ponderada por riesgo en las líneas de acción activos. Se omiten las medidas imposibles en todas las situaciones comparadas o junto con una elección más fuerte; las combinaciones improbables se permiten, así que revíselas usted mismo.",
  SUGGESTED_PICK: "elegida en {count} de {total} escenarios, peso {weight}",
  SUGGESTED_SKIPPED_EXCLUDED: "{value} omitida: imposible en todas las situaciones comparadas ({causes})",
  SUGGESTED_SKIPPED_CONFLICT: "{value} omitida: imposible junto con {causes}",
  SUGGESTED_NONE: "Sin sugerencia: ningún escenario eligió una medida",
  SUGGESTED_NONE_EXCLUDED: "Sin sugerencia: cada medida elegida es imposible en todas las situaciones comparadas",
  SUGGESTED_NONE_CONFLICT: "Sin sugerencia: cada medida elegida es imposible junto con una elección más fuerte",
  RESIDUAL_PROBABILITY: "Probabilidad tras esta línea de acción",
  RESIDUAL_IMPACT: "Impacto tras esta línea de acción",
  RESIDUAL_RISK: "Riesgo residual",
  COA_RISK_HINT: "Opcional: estime el riesgo que queda al ejecutar esta línea de acción. Se compara con el riesgo de la situación.",
  SITUATION_RISK_HINT: "Riesgo de la situación si no se interviene: la probabilidad de que se agrave o cause daños (adicionales) y el impacto si ocurre.",
  RISK_DOWN_FROM: "Baja desde {before}",
  RISK_UP_FROM: "Sube desde {before}",
  RISK_SAME_AS: "Igual que la situación ({before})",
  COA_RISK_SUMMARY: "Riesgo residual: {after} (situación: {before})",
  COA_RISK_SUMMARY_SHORT: "Riesgo residual: {after}",
  RISK_BEFORE_AFTER: "Riesgo: situación → tras la línea de acción",
  RISK_TRANSITION: "{before} → {after}",
  RISK_CHANGE: { lower: "Riesgo menor", same: "Mismo riesgo", higher: "Riesgo mayor" },
  RISK_NOT_SET: "sin indicar",
  DECISION_VIEW_RISK: "Matriz de riesgos",
  RISK_MATRIX_CAPTION: "Matriz de riesgos: probabilidad (filas) × impacto (columnas)",
  RISK_MATRIX_HINT: "Los números son el escenario actual (1) y los seleccionados para el análisis (riesgo de la situación); las letras son las líneas de acción del escenario seleccionado (riesgo residual).",
  RISK_MATRIX_MARKER: "Marcador",
  RISK_MATRIX_ITEM: "Escenario o línea de acción",
  RISK_MATRIX_CELL: "Probabilidad {probability}, impacto {impact}: riesgo {risk}",
  RISK_MATRIX_LEGEND: "Nivel de riesgo",
  RISK_LEVEL_HINT: { 0: 'Aceptable; no se necesitan medidas adicionales.', 1: 'Aceptable; vigilar la situación.', 2: 'Reducir el riesgo en la medida de lo razonable.', 3: 'Inaceptable; se necesitan medidas prioritarias.', 4: 'Inaceptable; actuar de inmediato.' },
  RISK_MATRIX_UNPLACED: "No representados (sin probabilidad o impacto): {items}",
  RISK_MATRIX_EMPTY: "Indique la probabilidad y el impacto de los escenarios incluidos para representarlos.",
  CRITERIA_SCORING: "Puntuación por criterios (opcional)",
  CRITERIA_HINT: "Puntúe cada línea de acción por criterio de 1 (malo) a 5 (bueno) e indique cuánto cuenta cada criterio (0 = ignorar). La puntuación ponderada es la suma de peso × puntuación.",
  CRITERIA: { effect: "Efecto", speed: "Rapidez", capacity: "Capacidad", safety: "Seguridad de los intervinientes", legality: "Legalidad", acceptance: "Aceptación pública" },
  CRITERIA_CRITERION: "Criterio",
  CRITERIA_WEIGHT: "Peso",
  CRITERIA_WEIGHT_FOR: "Peso de {criterion}",
  CRITERIA_SCORE_FOR: "Puntuación de la línea de acción {coa} para {criterion}",
  CRITERIA_TOTAL: "Puntuación ponderada",
  CRITERIA_RANK: "Posición",
  CRITERIA_TOTAL_OF: "{total} de {max}",
  CRITERIA_MISSING: "{count} sin puntuar",
  DECISION_EXPORT: "Exportar a Word",
  DECISION_EXPORT_TITLE: "Apoyo a la decisión",
  DECISION_EXPORT_DATE: "Exportado el {date}",
  DECISION_LOG: "Registro de decisiones",
  DECISION_LOG_HINT: "Registre las decisiones tomadas y su justificación. Las entradas se conservan cuando se elimina un escenario o una línea de acción.",
  DECISION_LOG_EMPTY: "Aún no hay decisiones registradas.",
  RECORD_DECISION: "Registrar decisión",
  EDIT_DECISION: "Editar decisión",
  DELETE_DECISION: "Eliminar decisión",
  DECISION_LOG_DATE: "Fecha y hora",
  DECISION_LOG_SCENARIO: "Escenario",
  DECISION_LOG_DECISION: "Decisión",
  DECISION_LOG_RATIONALE: "Justificación",
  DECISION_LOG_AUTHOR: "Decidido por",
  DECISION_LOG_REMOVED: "eliminado",
  DECISION_LOG_NO_SCENARIO: "Ningún escenario concreto",
  DECISION_LOG_NO_COA: "Ninguna línea de acción concreta",
  DECISION_LOG_EDITED: "editado el {date}",
  CRITERIA_NOT_SCORED: "sin puntuar",
  DECISION_PROMPT_TITLE: "¿Activar el apoyo a la decisión?",
  DECISION_PROMPT_MSG: "Esta caja contiene categorías de decisión, como medidas que elige después de describir la situación. Active el apoyo a la decisión para elegirlas y compararlas.",
  DECISION_PROMPT_LATER_NOTE: "Puede cambiarlo más tarde en Ajustes.",
  DECISION_PROMPT_ENABLE: "Activar",
  DECISION_PROMPT_NOT_NOW: "Ahora no",
  PROBABILITY: 'Probabilidad de ocurrencia',
  IMPACT: 'Impacto',
  RISK: 'Riesgo',
  RISK_PLACEHOLDER: 'Probabilidad x Impacto',
  PROB5: { 0: 'Muy baja', 1: 'Baja', 2: 'Media', 3: 'Alta', 4: 'Muy alta' },
  IMP5: { 0: 'Muy bajo', 1: 'Bajo', 2: 'Medio', 3: 'Alto', 4: 'Muy alto' },
  RISK5: { 0: 'Muy bajo', 1: 'Bajo', 2: 'Medio', 3: 'Alto', 4: 'Muy alto' },
  SUGGESTED_APPROACH: {
    TITLE: 'Enfoque sugerido',
    DESC: 'El enfoque sugerido es una combinación ponderada (por riesgo) de las contramedidas seleccionadas.',
  },
  TEMPLATE: {
    TITLE: 'Cadena de plantilla para texto fluido',
    DESC: 'Escriba un párrafo donde XXX sea reemplazado por el valor del factor clave 1, etc. Las líneas vacías se convierten en párrafos.',
  },
  SELECT_PERSONA: 'Seleccionar persona relevante para el escenario',
  SELECT_PERSONA_HELP: 'Registre cómo cada persona seleccionada percibe un escenario guardado, reacciona a las medidas y necesita información o participación.',
  PERSONA_IMPRESSION: 'Comentarios de la persona',
  COPY_PERSONA_PROMPT: 'Copiar prompt de comentarios',
  COPY_PERSONA_PROMPT_SHORT: 'Copiar',
  COPY_PERSONA_PROMPT_FOR: 'Copiar prompt de comentarios para {persona}',
  GENERATE_PERSONA_FEEDBACK: 'Generar comentarios',
  GENERATE_PERSONA_FEEDBACK_SHORT: 'Generar',
  GENERATE_PERSONA_FEEDBACK_FOR: 'Generar comentarios para {persona}',
  PERSONA_PROMPT_COPIED: "Prompt de comentarios copiado. Péguelo en el chat de su asistente de IA y pegue la respuesta en este campo.",
  PERSONA_PASTE_HINT: 'Pegue la respuesta del LLM directamente en el campo anterior; se guarda automáticamente.',
  PERSONA_FEEDBACK_ERROR: 'No se pudieron generar o copiar los comentarios. Inténtelo de nuevo.',
  PERSONA: {
    1: 'Persona',
    n: 'Personas',
  },
  IMAGE: 'Imagen',
  SAVE: 'Guardar',
  EDIT: 'Editar',
  MARKDOWN_FIELD_EMPTY: "Haga clic para añadir texto",
  LLM: 'LLM',
  SERVICE: 'Servicio',
  PROVIDER: 'Proveedor',
  SYSTEM_PROMPT: 'Prompt del sistema',
  USER_PROMPT: 'Prompt de narrativa',
  EFFECT_PROMPT: 'Prompt de efecto',
  PERSONA_PROMPT: 'Prompt de persona',
  COMMUNICATIONS_PROMPT: 'Prompt de comunicaciones',
  TEMPERATURE: {
    BTN: 'Temperatura',
    DESC: '¿Qué tan creativo debe ser el LLM (máx = 1)?',
  },
  API_KEY: 'Clave API',
  URL: 'URL',
  ASK_LLM: 'Consultar LLM',
  INCLUDE_LLM: 'Incluir en LLM',
  OLLAMA_URL:
    'Nombre del host (y puerto, opcionalmente a través de un [proxy](https://github.com/erikvullings/proxy))',
  ADV_EDIT: 'Editor de código',
  TOGGLE: { SHOW: 'Mostrar tabla', HIDE: 'Ocultar tabla' },
  AUTO_CREATE: {
    BTN: 'Crear automáticamente',
    COUNT: 'Cantidad de creación automática LLM',
    COUNT_DESC: '¿Cuántos escenarios desea generar a la vez?',
  },
  AUTO_CREATE_MSG: {
    1: `Crear automáticamente 1 escenario`,
    n: 'Crear automáticamente {n} escenarios',
  },
  COPY_BOX: {
    LABEL: 'Copiar caja',
    TITLE: 'Copiar tabla al portapapeles',
    TOAST: 'Caja morfológica copiada al portapapeles.',
  },
  PROMPT_TYPE: {
    PROMPTS: 'Prompts',
    LABEL: 'Tipo de prompt',
    NARRATIVE: 'Prompt de narrativa',
    EFFECT: 'Prompt de efecto',
    PERSONA: 'Prompt de persona',
    COM: 'Prompt de comunicaciones',
    DECISION: "Prompt de reflexión sobre decisiones",
  },
  LLM_DEFAULT_NARRATIVE_PROMPT:
    'Utiliza los siguientes elementos para definir un escenario realista.',
  LLM_INCLUDED_CATEGORIES: 'Categorías incluidas',
  LLM_PROMPT_TEXT: 'Prompt',
  LLM_CATEGORY_REQUIRED: 'Seleccione al menos una categoría para este prompt.',
  LLM_DEFAULT_PERSONA_PROMPT:
    'Describa cómo percibe esta situación la persona objetivo, incluidas las medidas propuestas y, cuando corresponda, cómo informarla o incluirla. Base los comentarios en el escenario y las descripciones de las personas; no invente detalles. Devuelva únicamente los comentarios para la persona objetivo, listos para pegarlos en su campo. No añada título, nombre de persona ni bloques de código.',
  LLM_PERSONA_CONTEXT: 'Personas seleccionadas y descripciones:\n{personas}',
  LLM_PERSONA_TARGET: 'Escriba comentarios solo para: {persona}',
  LLM_SCENARIO_TEXT: 'Narrativa del escenario:\n{narrative}',
  LLM_SITUATION: "Situación (use estos elementos para describir el incidente):",
  LLM_SUGGESTED_ACTIONS: "Acciones sugeridas (medidas que describir y evaluar):",
  LLM_NO_MEASURES_SELECTED: "No se seleccionaron medidas: describa solo el incidente y no invente medidas ni una solución.",
  LLM_DEFAULT_DECISION_PROMPT: "Usted es un asesor experimentado en gestión de crisis. Evalúe el curso de acción siguiente para la situación dada. Cíñase a la situación y a la narrativa del escenario; no invente hechos. Sea conciso: como máximo 250 palabras, en Markdown, con exactamente estas partes: **Valoración** (2–3 frases sobre la idoneidad, el momento y la secuencia), **Fortalezas** (2 viñetas), **Riesgos y carencias** (2–3 viñetas, incluido lo que falta) y **Mejora** (1 recomendación concreta). No añada título ni bloques de código.",
  LLM_DECISION_SITUATION: "Situación (el incidente al que responden las decisiones):",
  LLM_COA_DECISIONS: "Línea de acción {coa}: decisiones a evaluar:",
  LLM_COA_NO_DECISIONS: "La línea de acción {coa} aún no tiene decisiones seleccionadas: indique qué decisiones son necesarias.",
  LLM_OTHER_COAS: "Otras líneas de acción consideradas (solo para comparar; no las evalúe):",
  LLM_COMBINED_INTRO: "Realice todas las tareas siguientes para un escenario. Responda con un único objeto JSON en un bloque de código ```json y nada más.",
  LLM_COMBINED_TASK_NARRATIVE: "Tarea: escribir la narrativa del escenario",
  LLM_COMBINED_CURRENT_NARRATIVE: "Narrativa actual (mejórela y conserve lo que siga encajando):\n{narrative}",
  LLM_COMBINED_TASK_DECISIONS: "Tarea: evaluar cada línea de acción",
  LLM_COMBINED_TASK_PERSONAS: "Tarea: escribir comentarios para cada persona, basados en su narrativa",
  LLM_COMBINED_OUTPUT: "Formato de salida (estas reglas prevalecen sobre las instrucciones de formato anteriores): complete la plantilla JSON siguiente. No cambie ningún id, ponga un título breve y descriptivo en \"title\", escriba los textos en Markdown, use \\n para los saltos de línea dentro de las cadenas y no añada otros campos ni texto fuera del bloque de código.",
  COMBINED_PROMPT: "Prompt todo en uno",
  COMBINED_PROMPT_TITLE: "Un solo prompt para la narrativa, la evaluación de las líneas de acción y los comentarios de las personas; pegue la respuesta JSON",
  COMBINED_TITLE: "Prompt de IA todo en uno",
  COMBINED_HINT: "El prompt está en su portapapeles. Péguelo en su asistente de IA (por ejemplo Copilot) y pegue su respuesta JSON abajo. Esta ventana permanece abierta mientras tanto.",
  COMBINED_COPY: "Copiar prompt",
  COMBINED_COPIED: "Prompt copiado. Pegue la respuesta JSON abajo.",
  COMBINED_PASTE: "Respuesta de la IA (JSON)",
  COMBINED_PARSE_ERROR: "No se encontró JSON válido en esta respuesta. Pida a la IA que devuelva solo el bloque de código JSON.",
  COMBINED_APPLY: "Aplicar",
  COMBINED_APPLIED: "Escenario actualizado con la respuesta de la IA.",
  COMBINED_UNMATCHED: "No reconocido, omitido: {names}",
  COMBINED_REPLACES: "reemplaza el texto existente",
  COMBINED_FIELD_TITLE: "Título",
  COMBINED_FIELD_NARRATIVE: "Narrativa",
  COMBINED_HINT_API: "Genere la respuesta con el servicio de IA configurado, o copie el prompt y pegue la respuesta JSON abajo. Revise el resultado antes de aplicarlo.",
  COMBINED_GENERATE: "Generar",
  COMBINED_GENERATE_ERROR: "El servicio de IA no devolvió una respuesta. Revise la configuración del LLM o copie el prompt.",
  LLM_FIELD_PROMPTS: "Prompt por campo",
  LLM_FIELD_PROMPTS_DESC: "El prompt todo en uno sigue disponible. Muestre también un botón de prompt junto a la narrativa, cada evaluación y cada persona, para (re)generar solo esa parte.",
  AI_NARRATIVE: "Preguntar al LLM: escribir la narrativa",
  COPY_NARRATIVE_PROMPT: "Copiar prompt de la narrativa",
  NARRATIVE_PASTE_HINT: "Copie el prompt, pregunte a su asistente de IA y pegue la respuesta en el campo de la narrativa.",
  NARRATIVE_GENERATE_ERROR: "No se pudo generar la narrativa. Revise la configuración del LLM.",
  RESPONSE_INSTRUCTIONS:
    'Comience su respuesta con un título breve y descriptivo en su propia línea, luego una línea en blanco, luego el contenido principal.',
  WIZARD_STEP1_TITLE: 'Información de la caja',
  WIZARD_STEP1_SUBTITLE: 'Nombre y describa su caja',
  WIZARD_STEP2_TITLE: 'Factores clave',
  WIZARD_STEP2_SUBTITLE: 'Defina la categoría morfológica y los factores clave',
  WIZARD_STEP3_TITLE: 'Opciones de factores',
  WIZARD_STEP3_SUBTITLE: 'Opcionalmente agregue opciones para cada factor',
  WIZARD_CATEGORY_INFO: 'Detalles de categoría',
  WIZARD_COMPONENTS_INFO: 'Factores clave (dimensiones)',
  WIZARD_VALUES_INFO: 'Seleccione un factor para agregar opciones:',
  WIZARD_NO_COMPONENTS: 'No hay factores definidos aún. Regrese al paso 2.',
  WIZARD_VALUES_FOR_COMPONENT: 'Opciones para {component}',
  WIZARD_DEFAULT_CATEGORY_NAME: 'Caja Morfológica Inicial',
  WIZARD_NEXT: 'Siguiente',
  WIZARD_PREVIOUS: 'Atrás',
  WIZARD_COMPLETE: 'Crear caja',
  WIZARD_SKIP: 'Omitir',
  LLM_WIZARD_TITLE: 'Crear caja con IA',
  LLM_WIZARD_STEP1_TITLE: 'Definir requisitos',
  LLM_WIZARD_STEP1_SUBTITLE: 'Especifique lo que desea generar',
  LLM_WIZARD_STEP1_DESC:
    'Complete los detalles a continuación para personalizar la generación de su caja morfológica:',
  LLM_WIZARD_STEP2_TITLE: 'Revisar prompt',
  LLM_WIZARD_STEP2_SUBTITLE: 'Revise y edite el prompt completo',
  LLM_WIZARD_STEP2_DESC:
    'Revise el prompt combinado a continuación. Puede editarlo si es necesario:',
  LLM_WIZARD_STEP3_TITLE: 'Configurar LLM',
  LLM_WIZARD_STEP3_SUBTITLE: 'Elija el servicio y la configuración de LLM',
  LLM_WIZARD_STEP3_DESC: 'Configure cómo desea generar la caja morfológica:',
  LLM_WIZARD_STEP4_TITLE: 'Generar caja',
  LLM_WIZARD_STEP4_SUBTITLE: 'Genere o pegue el resultado',
  LLM_WIZARD_STEP4_CLIPBOARD_DESC:
    'El prompt está listo. Cópielo y use un LLM externo para generar la caja morfológica:',
  LLM_PURPOSE: 'Propósito',
  LLM_PURPOSE_HELP:
    '¿Qué desea explorar o diseñar? Por ejemplo, "escenarios de gestión de crisis para planificación de emergencias nacionales"',
  LLM_DOMAIN: 'Dominio',
  LLM_DOMAIN_HELP:
    'Especifique el campo o contexto, por ejemplo, "respuesta a desastres", "ciberseguridad", "operaciones militares"',
  LLM_OUTPUT_TYPE: 'Tipo de salida',
  LLM_OUTPUT_TYPE_HELP:
    '¿Una caja morfológica, múltiples cajas, enfocada en escenarios, enfocada en medidas, o ambas?',
  LLM_CONSTRAINTS: 'Restricciones o áreas de enfoque',
  LLM_CONSTRAINTS_HELP:
    'Por ejemplo, "Incluir factores sociopolíticos, ambientales y tecnológicos"',
  LLM_DETAIL_DEPTH: 'Profundidad de detalle',
  LLM_DETAIL_DEPTH_HELP:
    'Por ejemplo, "Incluir 6-7 opciones detalladas por factor, cada una con una definición de una oración"',
  LLM_LANGUAGE: 'Idioma de salida',
  LLM_LANGUAGE_HELP:
    'El idioma para el contenido generado, por ejemplo, "Inglés", "Español"',
  LLM_FULL_PROMPT: 'Prompt completo',
  LLM_ENDPOINT: 'Método de generación',
  LLM_CLIPBOARD: 'Copiar al portapapeles (usar LLM externo)',
  LLM_OLLAMA: 'Generar con Ollama',
  LLM_OPENAI: 'Generar con OpenAI',
  LLM_OLLAMA_URL_HELP:
    'URL de la API de Ollama, por ejemplo, http://localhost:11434/api/chat',
  LLM_OPENAI_URL_HELP:
    'URL de la API de OpenAI (dejar vacío para predeterminado)',
  LLM_OLLAMA_MODEL_HELP:
    'Nombre del modelo, por ejemplo, gemma2, llama3, qwen2.5',
  LLM_OPENAI_MODEL_HELP: 'Nombre del modelo, por ejemplo, gpt-4o-mini, gpt-4o',
  LLM_COPY_PROMPT: 'Copiar prompt al portapapeles',
  TEMPLATE_PROMPT_COPIED: 'Prompt de plantilla copiado al portapapeles',
  TEMPLATE_PROMPT_COPY: 'Copiar prompt de LLM al portapapeles',
  LLM_PROMPT_COPIED: '¡Prompt copiado al portapapeles!',
  LLM_PASTE_OUTPUT: 'Pegue la salida del LLM a continuación:',
  LLM_GENERATE: 'Generar con LLM',
  LLM_GENERATING: 'Generando con LLM...',
  LLM_ERROR: 'Error al generar',
  INCLUDE_MAP_SUPPORT: 'Activar soporte de mapa',
  SETTINGS_GENERAL: "General",
  SETTINGS_OPTIONS: "Opciones",
  SETTINGS_NARRATIVE: "Narrativa",
  SETTINGS_MAP: "Mapa",
  SETTINGS_STRUCTURE: "Estructura de la caja",
  HIDE_INCONSISTENT_HINT: "Al crear un escenario, ocultar las opciones imposibles con su selección, en lugar de solo marcarlas.",
  INCLUDE_MAP_SUPPORT_HINT: "Mostrar un mapa al definir la caja y al crear y ver escenarios, para situar los factores en un lugar.",
  INCLUDE_DECISION_SUPPORT_HINT: "Mostrar las categorías de medidas, las opciones de actuación y la página de decisión.",
  MAP_CONFIG: 'Configuración del mapa',
  MAP_UNITS: 'Unidades del mapa',
  METRIC: 'Métrico',
  IMPERIAL: 'Imperial',
  OSM_AMENITIES: 'Servicios OSM',
  TOGGLE_MAP: 'Mostrar/ocultar mapa',
  ZOOM_LEVEL: 'Nivel de zoom',
  CIRCLE: 'Círculo',
  ELLIPSE: 'Elipse',
  OSM_QUERY: 'Consulta OSM',
  RADIUS: 'Radio (m)',
  RADII: 'Radios (separados por coma, en metros)',
  MAJOR_AXIS: 'Eje mayor (m)',
  MINOR_AXIS: 'Eje menor (m)',
  ORIENTATION: 'Orientación',
  ORIENTATION_DESC: 'Ángulo en grados (0 = Norte) o ID de referencia',

  LLM_GENERATED_MARKDOWN: 'Markdown generado',

  IMPORT_FROM_SPREADSHEET: 'Pegar desde hoja de cálculo',
  IMPORT_PASTE_DATA: 'Pegar datos de la hoja de cálculo',
  IMPORT_PLACEHOLDER:
    'Pegue aquí los datos separados por tabulaciones de Excel/Google Sheets...\n\nPrimera fila = nombres de los factores clave, cada columna = opciones para ese factor.',
  IMPORT_PARSE: 'Analizar e importar',
  IMPORT_NO_DATA: 'No se detectaron datos tabulares. Pegue una tabla e inténtelo de nuevo.',
  IMPORT_NO_DRIVERS:
    'No se detectaron factores clave. Verifique los datos pegados.',
  IMPORT_NEEDS_TWO_COLUMNS:
    'La importación requiere al menos 2 columnas (nombres de factores clave y opciones).',
  CLOSE_MESSAGE: 'Cerrar mensaje',
  SEARCH_SCENARIO_TYPE: 'Buscar tipos de escenario…',
  NO_SCENARIO_TYPE_FOUND: 'No se encontraron tipos de escenario',
  COVERAGE_MENU: "Generar conjunto de cobertura…",
  COVERAGE_TITLE: "Generar escenarios que cubran la caja",
  COVERAGE_DESC: "Crea escenarios distintos en los que cada opción se usa aproximadamente con la misma frecuencia, en lugar de elegirlas al azar. Las opciones bloqueadas se mantienen, las combinaciones imposibles nunca se usan y las improbables se evitan. Los escenarios incluidos existentes cuentan para el equilibrio.",
  COVERAGE_COUNT: "Número de escenarios",
  COVERAGE_BATCH_NAME: "Nombre del lote (prefijo de los nombres de escenario)",
  COVERAGE_BATCH_DEFAULT: "Lote",
  COVERAGE_PAIRS: "Distribuir también las combinaciones de opciones (por pares)",
  COVERAGE_START: "Generar",
  COVERAGE_STOP: "Detener",
  COVERAGE_PROGRESS: "{done} de {total} escenarios",
  COVERAGE_DONE: "{count} escenarios añadidos a «{batch}»",
  COVERAGE_EXHAUSTED: "Solo se pudieron crear {count} escenarios nuevos, distintos y coherentes.",
  DELETE_BATCH_MENU: "Eliminar lote generado…",
  DELETE_BATCH_TITLE: "Eliminar un lote de escenarios generados",
  DELETE_BATCH_SELECT: "Lote",
  DELETE_BATCH_KEEP_TEXT: "Conservar los escenarios que ya tienen una narrativa",
  DELETE_BATCH_DONE: "{count} escenarios eliminados",
  SHOW_GENERATED: "Mostrar {count} escenarios generados sin narrativa",
};
